// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1XBgk","alert":"SettungsInbox_alert__1qIAn"};